
export const EFFIGY = 'http://www.sri.com/effigy#'
export const RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#'
export const SRC = 'http://www.sri.com/effigy/source#'
export const ENTITY = 'http://www.sri.com/effigy/entities#'

export const SRC5G = 'http://www.sri.com/effigy/3gpp#'
export const XSD = 'http://www.w3.org/2001/XMLSchema#'
